/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteOrgUploadDataRequest } from '../../models/delete-org-upload-data-request';
import { DeleteOrgUploadDataResponse } from '../../models/delete-org-upload-data-response';

export interface DeleteOrgUploadDataAsync$Plain$Params {
      body?: DeleteOrgUploadDataRequest
}

export function deleteOrgUploadDataAsync$Plain(http: HttpClient, rootUrl: string, params?: DeleteOrgUploadDataAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOrgUploadDataResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteOrgUploadDataAsync$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteOrgUploadDataResponse>;
    })
  );
}

deleteOrgUploadDataAsync$Plain.PATH = '/diagnose/delete-org-upload-data';
